<template>
  <div class="step-3">
    <div class="text-subtitle1 q-py-md">
      For more detailed instructions on performing an import visit the
      <a :href="__guide.importGeneralInstructions.url" class="text-tertiary" target="_blank" rel="noopener noreferrer">
        help section in the guide </a
      >.
    </div>

    <div class="text-h5">Step 1</div>

    <div class="text-subtitle1 q-py-sm">
      Fill out the spreadsheet
      <a
        :href="spreadsheetInformation.spreadsheet.sheets.imports[selection].url"
        target="_blank"
        rel="noopener noreferrer"
        class="text-tertiary"
      >
        here</a
      >. If copying data from Excel into GoogleSheets, please use the option to "Paste Special - Paste Values only"
    </div>

    <div class="text-h5">Step 2</div>

    <div class="text-subtitle1 q-py-sm">
      When ready click "Import" below and hang on while we import your data
    </div>

    <q-btn :loading="importClicked" label="Import" color="positive" @click="onImport" />

    <q-separator class="q-mt-md" />

    <template v-if="importClicked">
      <div class="text-h5">Import progress status</div>

      <div class="q-py-sm">
        <q-linear-progress stripe rounded size="20px" :value="importProgress" color="lm-green" class="q-mt-sm" />
      </div>
    </template>

    <Banner v-if="error" type="error" :message="error" />
  </div>
</template>

<script>
import * as apiTo from '../api'
import { pusher, subdomain } from '@/plugins/pusher'
// Libraries
import { mapState } from 'vuex'
// Components
import Banner from './Banner'

export default {
  components: {
    Banner
  },

  props: {
    value: Number,
    selection: {
      type: String,
      required: true
    }
  },

  data: () => ({
    importClicked: false,
    importProgress: 0.01,
    error: null
  }),

  computed: {
    ...mapState({ user: state => state.user }),
    ...mapState('data-imports', ['spreadsheetInformation']),

    step: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  created() {
    this.channel = pusher.subscribe(`private-${subdomain}.imports.${this.selection}.user.${this.user.id}`)

    this.channel.bind(`imports.${this.selection}.validation-errors`, ({ message }) => {
      this.importClicked = false
      this.error = message
      this.$emit('import-is-loading', false)
    })

    this.channel.bind(`imports.${this.selection}.unexpected-error`, ({ message }) => {
      this.importClicked = false
      this.error = message
      this.$emit('import-is-loading', false)
    })

    this.channel.bind(`imports.${this.selection}.import-complete`, ({ message, import_id }) => {
      this.$emit('complete', { message, importId: import_id })
    })

    this.channel.bind(`imports.${this.selection}.progress`, ({ progress }) => {
      this.importProgress = progress / 100
    })
  },

  beforeDestroy() {
    pusher.unsubscribe(this.channel.name)
  },

  methods: {
    onImport() {
      this.error = null
      this.importClicked = true
      apiTo.startImport(this.selection)
      this.$emit('import-is-loading', true)
    }
  }
}
</script>
